import APITemplate from '@/api/APITemplate'

const url = '/api/company-proxies'

const template = APITemplate(url)
export default {
  ...template
}
